// extracted by mini-css-extract-plugin
export default {"WorkListingInner":"WorkListing_WorkListingInner__lmqKD","workItem":"WorkListing_workItem__MWMtm","image":"WorkListing_image__0GUq-","workDesc":"WorkListing_workDesc__GRZhq"};